import { render, staticRenderFns } from "./StudentSurveyPaperEdit.vue?vue&type=template&id=0629ad8a&scoped=true"
import script from "./StudentSurveyPaperEdit.vue?vue&type=script&lang=js"
export * from "./StudentSurveyPaperEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629ad8a",
  null
  
)

export default component.exports